import { format_date, showModal, error, success, suppression } from "../utils/utils";
import Swal from "sweetalert2";
import { openKkiapayWidget, addKkiapayListener, removeKkiapayListener } from "kkiapay";

export class KKIAPAY {
  static check = {
    typeError: "RAS",
    idTransaction: 0,
  };
  static typeError = "RAS";
  static idTransaction = 0;

  static async successHandler(response: any): Promise<void> {
    this.typeError = "SUCCESS";
    this.idTransaction = response.transactionId;
    return Promise.resolve(); // Retourne une promesse vide
  }

  static async failHandler(response: any): Promise<void> {
    this.typeError = "ECHOUE";
    this.idTransaction = response.transactionId;
    return Promise.resolve(); // Retourne une promesse vide
  }

  static kkia(montant: number) {
    openKkiapayWidget({
      amount: montant,
      position: "center",
      theme: '#1c462e',
      countries: ["BJ"] as any,
      //sandbox: true,      
      //api_key: "d8115fa0652411efbf02478c5adba4b8",
      //phone: "61000000",
      api_key: "33388b0be82a3bf1d63749da803fa98f86292289",
      sandbox: false,
      phone: "",
    });
  }

  static addKkiapayListenerWrapper(eventType: string, handler: (response: any) => Promise<void>) {
    addKkiapayListener(eventType as any, handler);
  }
}